import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAsyncNew, defaultConfig } from './useAsyncNew';

const defaultSelectStateParams = () => null;

export const useStateAsync = (asyncFunction, config = { selectStateParams: defaultSelectStateParams }) => {
  const { clientQueryParameterName, selectStateParams, ...asyncConfig } = { ...defaultConfig, ...config };

  const clientId = useSelector((state) => {
    const { id: clientId } = state.account.selected;
    return clientId;
  });

  const service = useMemo(() => {
    let serviceChain = [];
    if (Array.isArray(asyncFunction)) {
      const [service, ...restServices] = asyncFunction;
      serviceChain = [
        async (...args) => {
          const [firstArg = {}, ...restArgs] = args;
          return service({ [clientQueryParameterName]: clientId, ...firstArg }, ...restArgs);
        },
        ...restServices,
      ];
    } else {
      serviceChain = [
        async (...args) => {
          const [firstArg = {}, ...restArgs] = args;
          return asyncFunction({ [clientQueryParameterName]: clientId, ...firstArg }, ...restArgs);
        },
      ];
    }
    return serviceChain;
  }, [asyncFunction, clientId]);

  const result = useAsyncNew(service, { ...asyncConfig, accountChange: clientId });

  return { ...result, clientId };
};

export default useStateAsync;
